{
  "common": {
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "done": "Done",
    "edit": "Edit",
    "search": "Search",
    "loading": "Loading…",
    "yes": "Yes",
    "no": "No",
    "settings": "Settings",
    "back": "Back",
    "close": "Close",
    "open": "Open",
    "copy": "Copy",
    "restore": "Restore",
    "untitled": "Untitled",
    "create": "Create",
    "revoke": "Revoke",
    "never": "Never",
    "tryAgain": "Try again",
    "reload": "Reload",
    "update": "Update",
    "insert": "Insert",
    "loadingShort": "Loading",
    "unknown": "Unknown",
    "sampleSentence": "The quick brown fox"
  },
  "sidebar": {
    "views": "Views",
    "tags": "Tags",
    "edit": "Edit",
    "done": "Done",
    "account": "Account",
    "newNote": "New note",
    "editTag": "Edit tag",
    "tagOptions": "Tag options",
    "reorder": "Reorder {{label}}",
    "showView": "Show {{label}}",
    "hideView": "Hide {{label}}",
    "editViews": "Edit views",
    "doneEditingViews": "Done editing views",
    "samplePeep": "Caliu is…",
    "sampleQuiet": "A quiet place for your thoughts to live and breathe."
  },
  "views": {
    "all": "All Notes",
    "today": "Today",
    "todo": "Todo",
    "pinned": "Pinned",
    "untagged": "Untagged",
    "thisWeek": "This Week",
    "shared": "Shared by me",
    "sharedWithMe": "Shared with me",
    "attachments": "Attachments",
    "trash": "Trash",
    "archive": "Archive"
  },
  "noteList": {
    "empty": "No notes yet",
    "emptySubtitle": "Create your first note to get started.",
    "untitled": "Untitled",
    "selectNote": "Select a note",
    "selectNoteHint": "Choose a note from the list, or create a new one.",
    "selectRestoreOrDelete": "Select a note to restore or permanently delete it",
    "selectSharedToView": "Select a shared note to view it",
    "searchPlaceholder": "Search notes…",
    "selectNotes": "Select Notes",
    "openSidebar": "Open sidebar",
    "cancelSelection": "Cancel Selection",
    "clearSelection": "Clear selection",
    "emptyTrash": "Empty Trash",
    "newNote": "New note",
    "noteCount_one": "{{count}} note",
    "noteCount_other": "{{count}} notes",
    "sortBy": "Sort by",
    "preview": "Preview",
    "modificationDate": "Modification Date",
    "creationDate": "Creation Date",
    "title": "Title",
    "manual": "Manual",
    "newestOnTop": "Newest on Top",
    "small": "Small",
    "medium": "Medium",
    "large": "Large",
    "empty_pinned": "Nothing pinned yet",
    "empty_pinned_subtitle": "Pin a note to find it quickly here.",
    "empty_today": "Nothing edited today",
    "empty_today_subtitle": "Notes you touch today will appear here.",
    "empty_todo": "No todos yet",
    "empty_todo_subtitle": "Notes with open task items will appear here.",
    "empty_untagged": "Everything is tagged",
    "empty_untagged_subtitle": "Notes without tags will appear here.",
    "empty_thisWeek": "Nothing this week",
    "empty_thisWeek_subtitle": "Notes edited in the last 7 days will appear here.",
    "empty_shared": "No shared notes",
    "empty_shared_subtitle": "Notes you share will appear here.",
    "empty_attachments": "No attachments yet",
    "empty_attachments_subtitle": "Notes with images or files will appear here.",
    "justNow": "Just now",
    "minutesAgo": "{{count}}m ago",
    "today": "Today",
    "yesterday": "Yesterday",
    "deletedOn": "Deleted {{date}}",
    "newNoteShortcut": "New note ({{shortcut}})",
    "noContent": "No content",
    "selectUnarchiveOrDelete": "Select a note to unarchive or delete it",
    "view": "View",
    "density": "Density",
    "exportAll": "Export all"
  },
  "editor": {
    "attachmentTooLarge": "This file is too large to attach. The limit is 100 MB.",
    "placeholder": "Start writing…",
    "noMatchingCommands": "No matching commands",
    "newNote": "new note",
    "noResults": "No results",
    "foldSection": "Fold section",
    "unfoldSection": "Unfold section",
    "dragSection": "Move section",
    "presenceLabel": "Also here: {{names}}"
  },
  "noteActions": {
    "pin": "Pin",
    "unpin": "Unpin",
    "pinToTop": "Pin to top",
    "makeReadOnly": "Make Read-Only",
    "makeEditable": "Make Editable",
    "readOnlyNote": "Read-only note",
    "shareNote": "Share note",
    "share": "Share",
    "publiclyShared": "Publicly shared",
    "privateNote": "Private note",
    "linkCreated": "Link created",
    "linkCreatedAndCopied": "Link created and copied",
    "linkRevoked": "Share link revoked",
    "failedToCreateShareLink": "Failed to create share link",
    "failedToRevokeShareLink": "Failed to revoke share link",
    "thisNoteIsPrivate": "This note is private.",
    "createPublicLink": "Create public link",
    "creatingLink": "Creating link…",
    "revokeLink": "Revoke link",
    "revokingLink": "Revoking…",
    "copyLink": "Copy link",
    "copyNoteId": "Copy note ID",
    "noteIdCopied": "Note ID copied",
    "exportAs": "Export as",
    "exportMarkdown": "Markdown",
    "exportPlainText": "Plain Text",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "Export failed",
    "viewHistory": "View history",
    "duplicate": "Duplicate",
    "duplicateFailed": "Couldn't duplicate note",
    "select": "Select",
    "delete": "Delete",
    "moveToTrash": "Move to trash",
    "archive": "Archive",
    "unarchive": "Unarchive",
    "tags": "Tags",
    "addTag": "Add tag",
    "noTagsYet": "No tags yet",
    "addTagFailed": "Couldn't add tag",
    "removeTagFailed": "Couldn't remove tag"
  },
  "userMenu": {
    "theme": "Theme",
    "typography": "Typography",
    "language": "Language",
    "apiKeys": "API Keys",
    "devices": "Devices",
    "connectedApps": "Connected apps",
    "help": "Help",
    "logOut": "Log out",
    "defaultUserName": "Caliu user",
    "editName": "Edit name",
    "nameLabel": "Name",
    "namePlaceholder": "Your name",
    "upgradeToPro": "Upgrade to Caliu Pro",
    "replayOnboarding": "Replay onboarding",
    "logOutTitle": "Log out?",
    "logOutBody": "Your notes stay on this device and you can keep reading and writing them. Sign in again to start syncing.",
    "logOutPending_one": "{{count}} change has not synced yet. It stays on this device until you sign in again.",
    "logOutPending_other": "{{count}} changes have not synced yet. They stay on this device until you sign in again.",
    "logOutKeep": "Log out",
    "logOutAndRemove": "Log out and remove notes"
  },
  "help": {
    "title": "Help Center",
    "searchPlaceholder": "Search help articles",
    "noResults": "No articles match your search.",
    "offline": "Help is unavailable offline. It will load next time you are connected."
  },
  "fonts": {
    "uiFont": "UI font",
    "body": "Body",
    "headings": "Headings",
    "code": "Code",
    "sans": "Sans",
    "serif": "Serif",
    "mono": "Mono",
    "editor": "Editor",
    "ui": "UI",
    "reset": "Reset to defaults"
  },
  "themes": {
    "light": "Light",
    "dark": "Dark",
    "system": "System"
  },
  "languages": {
    "systemHint": "Detected from your device",
    "names": {
      "en": "English",
      "es": "Spanish",
      "ca": "Catalan",
      "fr": "French",
      "de": "German",
      "it": "Italian",
      "pt": "Portuguese",
      "nl": "Dutch",
      "ja": "Japanese",
      "zh-CN": "Chinese (Simplified)",
      "ko": "Korean",
      "zh-TW": "Chinese (Traditional)",
      "ru": "Russian"
    }
  },
  "bulkActions": {
    "pinSelected": "Pin selected",
    "unpinSelected": "Unpin selected",
    "pin": "Pin",
    "addTag": "Add tag",
    "filterTags": "Filter tags…",
    "noTagsFound": "No tags found",
    "exportSelected": "Export selected",
    "restoreSelected": "Restore selected",
    "deletePermanently": "Delete permanently",
    "moveToTrash": "Move to trash",
    "archiveSelected": "Archive selected",
    "unarchiveSelected": "Unarchive selected",
    "exportingTitle": "Exporting your notes",
    "exportingBody": "This can take a moment. Keep this tab open until it finishes.",
    "exportingProgress": "{{done}} of {{total}}"
  },
  "commandPalette": {
    "placeholder": "Search notes, tags, commands…",
    "noResults": "No results for \"{{query}}\"",
    "currentNote": "Current Note",
    "navigation": "Navigation",
    "notes": "Notes",
    "tags": "Tags",
    "newNote": "New Note",
    "allNotes": "All Notes",
    "todaysNotes": "Today's Notes",
    "todo": "Todo",
    "pinnedNotes": "Pinned Notes",
    "trash": "Trash",
    "importNotes": "Import Notes",
    "changeTheme": "Change Theme",
    "keyboardShortcuts": "Keyboard Shortcuts",
    "pinNote": "Pin note",
    "unpinNote": "Unpin note",
    "restoreNote": "Restore note",
    "copyShareLink": "Copy share link",
    "makePrivate": "Make private",
    "toggleFullscreen": "Toggle fullscreen",
    "noteInfo": "Note info",
    "moveToTrash": "Move to trash",
    "archiveNote": "Archive note",
    "unarchiveNote": "Unarchive note",
    "archive": "Archive"
  },
  "noteHistory": {
    "title": "Note history",
    "requiresConnection": "Note history requires a connection.",
    "reconnect": "Reconnect to the internet and try again.",
    "noHistory": "No history yet for this note.",
    "windowMerged": "Edits within a 5-minute window are merged into one entry.",
    "selectVersion": "Select a version to preview",
    "encrypted": "Encrypted snapshot",
    "encryptedHint": "This version was saved with end-to-end encryption. Open the note to view the current contents.",
    "restoreVersion": "Restore this version?",
    "restoreVersionHint": "This will replace the current note content with the version from {{date}}.",
    "current": "Current",
    "created": "Created",
    "trashed": "Trashed",
    "restored": "Restored",
    "edited": "Edited"
  },
  "apiKeys": {
    "title": "API Keys",
    "empty": "No API keys yet.",
    "emptyHint": "Create one to start using the API.",
    "created": "Created {{date}}",
    "lastUsed": "Last used: {{date}}",
    "revokeKey": "Revoke key",
    "viewApiDocs": "View API docs",
    "newApiKey": "New API Key",
    "apiKeyCreated": "API Key Created",
    "createApiKey": "Create API Key",
    "copyHint": "Copy this key now. You won't be able to see it again.",
    "copyToClipboard": "Copy to clipboard",
    "keyName": "Key name",
    "keyNamePlaceholder": "e.g. My Script, Zapier Integration",
    "createKey": "Create Key",
    "revokeKeyTitle": "Revoke API Key",
    "revokeKeyHint": "This will permanently revoke this API key. Any applications using it will lose access immediately.",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "Connected apps",
    "empty": "No connected apps yet.",
    "emptyHint": "Connect Claude, ChatGPT, or another AI assistant to use your notes from the chat. The Caliu with AI section in Help shows how.",
    "connected": "Connected {{date}}",
    "lastUsed": "Last used: {{date}}",
    "revoke": "Revoke",
    "revokeTitle": "Revoke connection",
    "revokeHint": "This will revoke <strong>{{name}}</strong>'s access to your Caliu account and delete the credentials it was using. It will lose access immediately.",
    "thisApp": "this app",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "Writing",
    "metadata": "Metadata",
    "words": "Words",
    "characters": "Characters",
    "paragraphs": "Paragraphs",
    "readTime": "Read time",
    "minutes": "{{count}} min",
    "tags": "Tags",
    "outgoingLinks": "Outgoing links",
    "backlinks": "Backlinks",
    "created": "Created",
    "modified": "Modified",
    "noteStatistics": "Note statistics",
    "identifier": "Identifier"
  },
  "inspector": {
    "tabInfo": "Info",
    "tabOutline": "Outline",
    "tabHistory": "History",
    "dates": "Dates",
    "noHeadings": "No headings in this note",
    "noBacklinks": "No notes link here",
    "noOutgoing": "This note links to nothing",
    "noAttachments": "No attachments in this note",
    "historyOffline": "Version history needs a connection",
    "historyLoadMore": "Load more"
  },
  "devices": {
    "title": "Devices",
    "offline": "You're offline.",
    "offlineHint": "Connect to the internet to see your devices.",
    "noSessions": "No active sessions found.",
    "thisDevice": "This device",
    "lastUsed": "Last used: {{date}}",
    "created": "Created: {{date}}",
    "signOutCurrent": "Sign out of this device",
    "signOut": "Sign out",
    "confirmCurrentTitle": "Sign out of this device?",
    "confirmRevokeTitle": "Revoke device?",
    "confirmCurrentBody": "You'll be signed out of Caliu on this browser, and the notes on it are removed from this device. Sign back in any time and they come back from your account.",
    "confirmRevokeBody": "This will sign out the device immediately. Any unsynced changes on it will stay there until you sign in again.",
    "revoke": "Revoke"
  },
  "errorScreen": {
    "title": "Something went wrong",
    "defaultMessage": "An unexpected error occurred. Try reloading the page."
  },
  "importModal": {
    "title": "Import notes",
    "dropToImport": "Drop to import",
    "dropOrClick": "Drop files or click to browse",
    "removeFile": "Remove file",
    "keepNote": "For Google Keep, export a Takeout ZIP and upload that archive directly.",
    "importedCount_one": "Imported <strong>{{count}}</strong> note",
    "importedCount_other": "Imported <strong>{{count}}</strong> notes",
    "fromSource": " from {{source}}",
    "importing": "Importing…",
    "importN": "Import {{count}} files",
    "importBtn": "Import"
  },
  "share": {
    "shareNote": "Share note",
    "publiclySharedAria": "Note is publicly shared",
    "copyLink": "Copy link",
    "revokingLink": "Revoking…",
    "revokeLink": "Revoke link",
    "creatingLink": "Creating link…",
    "createPublicLink": "Create public link",
    "shareThisNotePublicly": "Share this note publicly",
    "thisNoteIsPrivate": "This note is private.",
    "publiclyShared": "Publicly shared",
    "privateNote": "Private note"
  },
  "shortcuts": {
    "searchPlaceholder": "Search shortcuts…",
    "pressNew": "Press new shortcut…",
    "resetToDefault": "Reset to default",
    "noMatches": "No shortcuts matching “<strong>{{query}}</strong>”",
    "navigate": "navigate",
    "edit": "edit",
    "closeAction": "close",
    "resetAll": "Reset all"
  },
  "tagEditor": {
    "icon": "Icon",
    "color": "Color",
    "searchIcons": "Search icons",
    "noIcons": "No icons match",
    "categories": {
      "essentials": "Essentials",
      "work": "Work & tech",
      "ideas": "Ideas & creativity",
      "life": "People & home",
      "travel": "Travel & nature",
      "fun": "Food, health & fun"
    }
  },
  "tagActions": {
    "pin": "Pin tag",
    "unpin": "Unpin tag",
    "rename": "Rename…",
    "renameTitle": "Rename tag",
    "renameConfirm": "Rename",
    "renameHint": "The tag is updated in every note that uses it, including archived notes and trash.",
    "renamed": "Tag renamed",
    "nameInUse": "That name is already in use",
    "invalidName": "Tag names can only use letters, numbers, spaces, hyphens and underscores",
    "pinFailed": "Couldn't update tag",
    "renameFailed": "Couldn't rename tag",
    "editAppearance": "Edit appearance"
  },
  "auth": {
    "appName": "Caliu",
    "or": "or",
    "email": "Email",
    "emailPlaceholder": "you@example.com",
    "password": "Password",
    "passwordPlaceholder": "Password",
    "name": "Name",
    "namePlaceholder": "Your name",
    "confirmPassword": "Confirm password",
    "newPassword": "New password",
    "confirmNewPassword": "Confirm new password",
    "signInSubtitle": "Sign in to your account",
    "createAccountSubtitle": "Create your account",
    "forgotPassword": "Forgot password?",
    "signingIn": "Signing in…",
    "signIn": "Sign in",
    "noAccount": "Don’t have an account?",
    "signUp": "Sign up",
    "haveAccount": "Already have an account?",
    "creatingAccount": "Creating account…",
    "createAccount": "Create account",
    "googleSignUpAria": "Sign up with Google",
    "signupClosedTitle": "Sign up is currently closed",
    "signupClosedBody": "Caliu is in private beta. Join the waitlist at caliuapp.com to get early access.",
    "joinWaitlist": "Join the waitlist",
    "forgotTitle": "Reset password",
    "forgotSubtitle": "Enter your email and we’ll send you a reset link.",
    "sendResetLink": "Send reset link",
    "sending": "Sending…",
    "checkYourEmail": "Check your email",
    "resetLinkSentPrefix": "If ",
    "resetLinkSentSuffix": " has an account, we’ve sent a password reset link. It expires in 1 hour.",
    "backToSignIn": "Back to sign in",
    "verifySentPrefix": "We sent a verification link to ",
    "verifySentSuffix": ". Click it to activate your account.",
    "linkExpires10m": "The link expires in 10 minutes.",
    "resending": "Resending…",
    "resendEmail": "Resend email",
    "wrongEmail": "Wrong email?",
    "goBack": "Go back",
    "invalidResetLinkTitle": "Invalid reset link",
    "invalidResetLinkBody": "This link is invalid or has expired.",
    "requestNewLink": "Request a new link",
    "setNewPasswordTitle": "Set new password",
    "setNewPasswordHint": "Choose a strong password.",
    "updatingPassword": "Updating…",
    "updatePassword": "Update password",
    "localNotesTitle": "You have notes on this device",
    "localNotesBody_one": "You wrote {{count}} note here before signing in. What should happen to it?",
    "localNotesBody_other": "You wrote {{count}} notes here before signing in. What should happen to them?",
    "localNotesDelete": "Delete them",
    "localNotesMerge": "Add them to my account",
    "backToMyNotes": "Back to my notes",
    "errorGoogleAuthFailed": "Google sign-in failed. Please try again.",
    "errorInvalidToken": "Invalid verification link. Please register again.",
    "errorEmailTaken": "This email is already in use. Please sign in.",
    "signInInstead": "Sign in to that account instead",
    "errorIdentityTaken": "That identity already belongs to another Caliu account. Sign in to it instead.",
    "parkedNotesTitle": "Notes from another account",
    "parkedNotesBody_one": "Sign in to {{email}} to keep its notes on this device. A different account clears the one note here, including anything written since.",
    "parkedNotesBody_other": "Sign in to {{email}} to keep its notes on this device. A different account clears all {{count}} notes here, including anything written since.",
    "parkedNotesBodyNoEmail_one": "Sign in to the account you signed out of to keep its notes on this device. A different account clears the one note here, including anything written since.",
    "parkedNotesBodyNoEmail_other": "Sign in to the account you signed out of to keep its notes on this device. A different account clears all {{count}} notes here, including anything written since.",
    "parkedNotesContinue": "Continue"
  },
  "connectors": {
    "wantsAccess": "wants access to Caliu",
    "couldntLoad": "Couldn't load this request",
    "authorize": "Authorize",
    "keepHappeningHint": "If this keeps happening, remove the connector from your MCP client and add it again.",
    "backToCaliu": "Back to Caliu",
    "askingPermissionPrefix": "is asking for permission to read and modify your notes and tags through Caliu’s MCP server.",
    "signedInAs": "Signed in as {{name}}.",
    "permissions": "Permissions",
    "deny": "Deny",
    "allow": "Allow"
  },
  "editorTypography": {
    "fontSize": "Font size",
    "lineHeight": "Line height",
    "paragraphSpacing": "Paragraph spacing"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Shift"
  },
  "floatingMenu": {
    "undo": "Undo",
    "redo": "Redo",
    "taskList": "Task list",
    "bulletList": "Bullet list",
    "orderedList": "Ordered list",
    "blockQuote": "Block quote",
    "separator": "Separator",
    "insertTag": "Insert tag",
    "highlight": "Highlight",
    "math": "Math",
    "removeHighlight": "Remove highlight",
    "inlineCode": "Inline code",
    "codeBlock": "Code block",
    "insertTable": "Insert table",
    "insertImage": "Insert image",
    "hideStyleBar": "Hide style bar",
    "attachFile": "Attach file",
    "photoLibrary": "Photo library",
    "camera": "Camera",
    "fromFile": "From file"
  },
  "imageDialog": {
    "title": "Insert image",
    "tabUpload": "File",
    "tabUrl": "URL",
    "urlLabel": "Image URL",
    "urlPlaceholder": "https://example.com/image.jpg",
    "altLabel": "Alt text",
    "altPlaceholder": "Describe the image…",
    "previewAlt": "preview",
    "changeImage": "Change image",
    "dropToInsert": "Drop to insert",
    "dropOrClick": "Drop an image or click to browse",
    "formats": "PNG, JPG, GIF, WebP",
    "insert": "Insert image"
  },
  "linkDialog": {
    "editTitle": "Edit link",
    "insertTitle": "Insert link",
    "textLabel": "Text",
    "textPlaceholder": "Link text",
    "urlPlaceholder": "https://example.com",
    "removeLink": "Remove link",
    "openLink": "Open link",
    "editLink": "Edit link"
  },
  "noteEditor": {
    "notFound": "Note not found.",
    "inTrashBanner": "This note is in the trash. Restore it to make edits.",
    "restore": "Restore",
    "noContent": "This note has no content."
  },
  "noteHeader": {
    "noteInfo": "Note info"
  },
  "table": {
    "deleteRow": "Delete row",
    "deleteTable": "Delete table",
    "addRow": "Add Row",
    "addRowAbove": "Add Row Above",
    "addColumn": "Add Column",
    "addColumnBefore": "Add Column Before",
    "moveRowUp": "Move Row Up",
    "moveRowDown": "Move Row Down",
    "moveColumnLeft": "Move Column Left",
    "moveColumnRight": "Move Column Right",
    "deleteColumn": "Delete Column",
    "actions": "Table actions"
  },
  "syncIndicator": {
    "synced": "Synced",
    "pending_one": "{{count}} pending sync",
    "pending_other": "{{count}} pending syncs",
    "offline": "Offline",
    "offlinePending_one": "Offline · {{count}} pending",
    "offlinePending_other": "Offline · {{count}} pending",
    "syncing": "Syncing...",
    "conflict_one": "{{count}} conflict",
    "conflict_other": "{{count}} conflicts",
    "error": "Sync error",
    "syncedTooltip": "All changes saved",
    "pendingTooltip_one": "{{count}} change waiting to sync",
    "pendingTooltip_other": "{{count}} changes waiting to sync",
    "offlineTooltip": "Offline: changes will sync when reconnected",
    "offlinePendingTooltip_one": "Offline: {{count}} change will sync when reconnected",
    "offlinePendingTooltip_other": "Offline: {{count}} changes will sync when reconnected",
    "syncingTooltip": "Syncing...",
    "syncingPendingTooltip_one": "Syncing {{count}} pending change...",
    "syncingPendingTooltip_other": "Syncing {{count}} pending changes...",
    "conflictTooltip_one": "{{count}} note has conflicting changes. Click to resolve.",
    "conflictTooltip_other": "{{count}} notes have conflicting changes. Click to resolve.",
    "errorTooltip": "Sync failed. Will retry automatically.",
    "conflictsTitle": "Resolve conflicts",
    "local": "On this device",
    "localTooltip": "On this device only. Sign in to sync."
  },
  "image": {
    "download": "Download image",
    "replace": "Replace image",
    "remove": "Remove image"
  },
  "sharePage": {
    "goToCaliu": "Go to Caliu",
    "noteNotFoundTitle": "Note not found",
    "somethingWentWrong": "Something went wrong",
    "lastUpdated": "Last updated: {{date}}",
    "tagline": "A notes app for thinkers",
    "subtagline": "Write in markdown. Sync everywhere. Think clearly.",
    "startWriting": "Start writing",
    "signIn": "Sign in",
    "openInCaliu": "Open in Caliu",
    "adding": "Adding…",
    "addToSharedList": "Add to my shared list",
    "notFoundSubtitle": "This share link may have expired or been revoked.",
    "errorSubtitle": "Unable to load this note. Please try again."
  },
  "sharedView": {
    "loading": "Loading shared note…",
    "sharedWithYou": "Shared with you",
    "viewRaw": "View raw Markdown",
    "viewRendered": "View rendered note",
    "copyMarkdown": "Copy Markdown",
    "markdownCopied": "Markdown copied",
    "copyFailed": "Copy failed",
    "notLoadedYet": "This note has not finished loading yet",
    "linkCopied": "Link copied",
    "actions": "Note actions"
  },
  "sharedWithMe": {
    "title": "Shared with me",
    "removeFromList": "Remove from list",
    "empty": "No shared notes yet",
    "emptyHint": "Open a Caliu share link from a friend to add it here. Shared notes sync across your devices."
  },
  "trashView": {
    "empty": "Trash is empty",
    "emptyHint": "Deleted notes will appear here",
    "retention": "Notes in trash are deleted permanently after 30 days",
    "trash": "Trash"
  },
  "fileAttachment": {
    "download": "Download file",
    "remove": "Remove file"
  },
  "archiveView": {
    "archive": "Archive",
    "empty": "Archive is empty",
    "emptyHint": "Archived notes will appear here",
    "archivedOn": "Archived {{date}}"
  },
  "pro": {
    "subtitle": "Caliu, with nothing held back.",
    "features": [
      "Unlimited notes",
      "Note version history",
      "Export to PDF, HTML, RTF, ePub + bulk",
      "All themes, fonts and app icons",
      "Supports Caliu's development"
    ],
    "perMonth": "{{price}} per month",
    "perWeek": "{{price}} per week",
    "oneTime": "{{price}} one time",
    "perYear": "{{price}} per year",
    "or": "or",
    "signInToSubscribe": "Sign in to subscribe",
    "accountRequired": "Caliu Pro is tied to your account, so it unlocks on every device.",
    "plansUnavailable": "We couldn't load the plans. Check your connection and try again.",
    "yearly": "Yearly",
    "monthly": "Monthly",
    "continue": "Continue",
    "bestValue": "Best value",
    "autoRenew": "{{amount}}. Auto-renews until canceled. Cancel anytime.",
    "freeTrial": "Free for {{count}} days",
    "billedSubtitle": "Free for {{count}} days, then {{amount}}. Cancel anytime.",
    "startTrial": "Start free trial",
    "upgradeSubtitle": "Version history, every theme and font, export, and more.",
    "upgradeNow": "Upgrade now",
    "thanks": "Thanks for supporting Caliu!",
    "renewsOn": "Renews {{date}}",
    "endsOn": "Ends {{date}}",
    "lifetime": "Lifetime access",
    "lifetimePlan": "Lifetime",
    "oneTimeNoRenewal": "One-time payment",
    "launchPrice": "Launch price. It will later rise to {{price}}.",
    "buy": "Buy",
    "oneTimeDisclosure": "{{amount}}. One-time payment, no renewal.",
    "thanksMessage": "Your support keeps Caliu independent and private.",
    "manageSubscription": "Manage subscription",
    "contactUs": "Questions? Contact us",
    "grandfatheredNote": "As an early supporter, Caliu Pro is yours for life. Nothing to renew.",
    "webFootnote": "PDF export isn't available on the web yet.",
    "active": "Active"
  },
  "find": {
    "placeholder": "Find in note",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "No results",
    "next": "Next match",
    "previous": "Previous match",
    "close": "Close"
  },
  "conflicts": {
    "description": "This note was edited on another device. Keep one version.",
    "yours": "Your version",
    "theirs": "Their version",
    "step": "{{current}} of {{total}}",
    "keepYours": "Keep yours",
    "keepTheirs": "Keep theirs",
    "serverError": "Could not load the other version.",
    "done": "All conflicts resolved.",
    "previous": "Previous conflict",
    "next": "Next conflict",
    "copyOf": "Copy of {{title}}"
  },
  "onboarding": {
    "welcomeTitle": "Welcome to Caliu",
    "welcomeSubtitle": "A quiet place for your thoughts to live and breathe.",
    "getStarted": "Get started",
    "magicTitle": "Watch your words take shape",
    "magicSubtitle": "You write plain text. Caliu turns it into structure: tasks, highlights, and tags that file themselves.",
    "magicLearnMore": "Learn Markdown basics",
    "replay": "Replay",
    "demoTitle": "Summer by the sea",
    "demoBody": "Plan a **slow week** in a small town.",
    "demoTask": "Book the little house",
    "demoHighlight": "Swim ==before== breakfast",
    "demoTags": "#summer #plans",
    "intentTitle": "What will you bring here?",
    "intentSubtitle": "Choose a few. Your first note and tags will be waiting, already yours.",
    "themeTitle": "Pick your light",
    "themeSubtitle": "Themes to match the mood of your writing.",
    "proTitle": "Begin with everything",
    "proSubtitle": "Begin with everything from day one. Try it free, keep it only if it earns its place.",
    "proTrust": "No ads. No tricks. Cancel anytime.",
    "tryProFree": "Try Pro for free",
    "continueFree": "Continue with the free plan",
    "allSetTitle": "You're all set",
    "allSetSubtitle": "Welcome to Caliu. Make it yours.",
    "startWriting": "Start writing",
    "firstNoteTitle": "Where it begins",
    "firstNoteBody": "This is my first note. It lives on this device, works offline, and follows me everywhere.",
    "firstNoteTask": "Write down one thought worth keeping",
    "next": "Next",
    "skip": "Skip",
    "back": "Back",
    "intents": {
      "journal": "Journal",
      "ideas": "Ideas",
      "work": "Work",
      "study": "Study",
      "reading": "Reading",
      "plans": "Plans"
    },
    "signInCta": "Sign in or create account",
    "continueWithoutAccount": "Continue without an account",
    "backupTitle": "Where your notes live",
    "backupSubtitle": "They start on this device. An account syncs them, so a safe copy reaches all your devices.",
    "syncOffTitle": "Sync is off",
    "syncOffBody": "Sign in to sync your notes across your devices.",
    "backupSignedIn": "Your notes are synced securely as you write.",
    "backupStageDevice": "This device",
    "backupStageSafe": "Synced",
    "backupStageEverywhere": "All your devices",
    "freeNotes": "{{limit}} free notes, no account, forever. Pro makes them unlimited."
  },
  "backup": {
    "evictionNotice": "Notes live only in this browser for now. Browsers can clear site data when space runs low.",
    "dismiss": "Dismiss",
    "signIn": "Sign in"
  },
  "gate": {
    "share": "Sign in to share notes.",
    "history": "Sign in to keep version history.",
    "import": "Sign in to import notes."
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "LaTeX source"
  },
  "noteLimit": {
    "banner": "{{count}} of {{limit}} notes",
    "paywallTitle": "You've reached {{limit}} free notes",
    "paywallBody": "Editing, search and sync keep working. Trash a note to free a slot, or go unlimited with Caliu Pro, monthly, yearly or with a one-time lifetime purchase.",
    "importCapped": "Only {{count}} of {{total}} files were imported: the free plan allows {{limit}} notes."
  },
  "appUpdate": {
    "available": "A new version of Caliu is available."
  },
  "settings": {
    "title": "Settings",
    "account": "Account",
    "writing": "Writing",
    "keyboardShortcuts": "Keyboard Shortcuts",
    "editor": "Editor",
    "yourNotes": "Your notes",
    "about": "About",
    "noAccount": "No account",
    "sendFeedback": "Send feedback",
    "signInOrCreate": "Sign in or create account",
    "notesComeWithYou": "Your notes on this device come with you.",
    "notSyncing": "Not syncing",
    "signInToSync": "Sign in to sync your notes.",
    "sync": "Sync",
    "security": "Security",
    "communications": "Communications",
    "newsletter": "Caliu newsletter",
    "newsletterFooter": "A short email now and then about new releases and what is coming to Caliu.",
    "newsletterError": "Couldn't update the newsletter. Try again.",
    "appearance": "Appearance",
    "themes": "Themes",
    "sizing": "Sizing",
    "systemDefault": "System default",
    "separateThemes": "Separate light and dark themes",
    "maxWidth": "Max width",
    "maxWidthHint": "Centers text in a readable column on wide screens",
    "markdownReturn": "Markdown-style Return",
    "markdownReturnHint": "Return breaks the line. Press Return twice for a new paragraph",
    "newNoteStart": "New notes start with",
    "newNoteStartH1": "Heading 1",
    "newNoteStartH2": "Heading 2",
    "newNoteStartH3": "Heading 3",
    "newNoteStartH4": "Heading 4",
    "newNoteStartDate": "Date",
    "newNoteStartDateIso": "Date (ISO 8601)",
    "newNoteStartDateTime": "Date and time",
    "newNoteStartDateTimeIso": "Date and time (ISO 8601)",
    "newNoteStartEmpty": "Empty",
    "newNoteStartHint": "Applies to notes you create in the app.",
    "collapsibleSections": "Collapsible sections",
    "collapsibleSectionsHint": "Lets you fold a heading and its content behind a chevron",
    "experimental": "Experimental",
    "general": "General"
  },
  "toolbar": {
    "toggleSidebar": "Toggle Sidebar",
    "toggleInspector": "Toggle Inspector",
    "searchNotes": "Search Notes",
    "newNote": "New Note",
    "findInNote": "Find in Note",
    "showToolbar": "Show Toolbar",
    "hideToolbar": "Hide Toolbar",
    "moreNoteActions": "More Note Actions",
    "undo": "Undo",
    "redo": "Redo",
    "zenMode": "Zen Mode",
    "sourceMode": "Source Mode",
    "richEditor": "Rich Editor",
    "sortBy": "Sort By",
    "bold": "Bold",
    "italic": "Italic",
    "heading": "Heading",
    "list": "List",
    "link": "Link",
    "insert": "Insert",
    "more": "More",
    "strikethrough": "Strikethrough",
    "table": "Table",
    "horizontalRule": "Horizontal Rule",
    "codeBlock": "Code Block",
    "inlineCode": "Inline Code",
    "blockQuote": "Block Quote",
    "math": "Math",
    "highlight": "Highlight",
    "bulletList": "Bullet List",
    "orderedList": "Ordered List",
    "photoLibrary": "Photo Library",
    "camera": "Camera",
    "files": "Files",
    "yellow": "Yellow",
    "green": "Green",
    "blue": "Blue",
    "pink": "Pink",
    "purple": "Purple",
    "heading1": "Heading 1",
    "heading2": "Heading 2",
    "heading3": "Heading 3",
    "heading4": "Heading 4",
    "heading5": "Heading 5",
    "heading6": "Heading 6",
    "removeHighlight": "Remove Highlight"
  },
  "whatsNew": {
    "title": "What's new",
    "tagIconsTitle": "Icons drawn for Caliu",
    "tagIconsBody": "Every icon in the app is new and made for Caliu. Give every tag its own icon, and search them in your language.",
    "newNoteStartTitle": "Start notes your way",
    "newNoteStartBody": "A new note can open on a heading, today's date, the date and time, or an empty page. Choose it in Settings, under Editor.",
    "typographyTitle": "Type, set exactly",
    "typographyBody": "Choose the exact text size, line height and paragraph spacing for your notes, in Settings under Typography.",
    "typographySample": "Every note follows the size, line height and spacing you set, down to the point.",
    "sampleMorningPages": "Morning pages",
    "newsletterTitle": "Introducing the Caliu newsletter",
    "newsletterBody": "From now on, a short email tells you what's new in each release, in your language. Turn it on if you'd like it. You can change it anytime in Settings."
  },
  "sharing": {
    "inviteByEmail": "Invite by email",
    "invite": "Invite",
    "roleOwner": "Owner",
    "roleEditor": "Can edit",
    "roleViewer": "Can view",
    "generalAccess": "General access",
    "shareWithLink": "Share with a link",
    "accessRestricted": "Only people invited",
    "accessView": "Anyone with the link can view",
    "accessEdit": "Anyone with the link can edit",
    "remove": "Remove",
    "leave": "Leave",
    "leaveNote": "Leave note",
    "leaveConfirmTitle": "Leave this note?",
    "leaveConfirmBody": "It will disappear from your lists on every device. The owner can invite you again.",
    "leaveSelectedTitle": "Leave shared notes?",
    "leaveSelectedBody_one": "You will leave {{count}} note shared with you. Your own notes move to the trash.",
    "leaveSelectedBody_other": "You will leave {{count}} notes shared with you. Your own notes move to the trash.",
    "sharedBy": "Shared by {{name}}",
    "sharedList": "Shared",
    "viewOnly": "View only",
    "accessNowEditor": "You can now edit this note.",
    "accessNowViewer": "You can now only view this note.",
    "accessRemoved": "You no longer have access to this note.",
    "unsentSavedAsCopy": "Your unsent changes were saved as a copy.",
    "privateNote": "Private note",
    "memberLimit": "A note can be shared with up to 50 people.",
    "rateLimit": "Too many invites. Try again later.",
    "inviteFailed": "Couldn't send the invites. Try again.",
    "invalidEmail": "Enter a valid email address.",
    "onlineOnly": "Connect to the internet to manage sharing.",
    "you": "You",
    "ownerOnly": "Only the owner can change who has access.",
    "unavailable": "Sharing is unavailable right now. Try again later.",
    "updateFailed": "Couldn't update sharing. Try again.",
    "inviteInvalid": "This invite is no longer valid.",
    "copyLink": "Copy link",
    "invited": "Invited",
    "copied": "Copied",
    "accessRestrictedHint": "Only people you invite can open it.",
    "onlyYouHint": "Only you can open it.",
    "accessViewHint": "Anyone with the link can read it, no account needed.",
    "accessEditHint": "Anyone with the link can edit it.",
    "roleBelowLink": "Anyone with the link can edit, so people you invite can edit too.",
    "inviteAs": "Invite as",
    "revokeInvite": "Revoke invite",
    "statusPeople_one": "{{count}} person",
    "statusPeople_other": "{{count}} people",
    "publicLink": "Public link",
    "statusFrom": "From {{name}}",
    "removeConfirmTitle": "Remove {{name}}?",
    "removeConfirmBody": "They will no longer have access to this note.",
    "revokeConfirmTitle": "Revoke the invite to {{name}}?",
    "revokeConfirmBody": "The invite link will stop working.",
    "peopleWithAccess": "People with access",
    "addPeoplePlaceholder": "Add people by email",
    "invitePro": "Inviting people is part of Caliu Pro.",
    "inviteKeepsAccess": "Invited people keep access if you turn the link off.",
    "youSuffix": "(you)"
  },
  "noAccess": {
    "title": "You don't have access to this note",
    "linkBody": "Its owner hasn't shared it with you. Ask them to invite you, or to turn on its link.",
    "signedOutBody": "Sign in with the account it was shared with.",
    "inviteTitle": "This invite is no longer valid",
    "inviteBody": "Ask the person who invited you for a new one.",
    "removedTitle": "You no longer have access to this note",
    "removedBody": "Its owner removed you.",
    "removedCopyBody": "Its owner removed you. Your unsent changes were kept as a copy in your notes.",
    "backToNotes": "Back to notes",
    "signIn": "Sign in"
  }
}
